import React from 'react';
import Wrapper from '../../../../../../../../../shared/components/Wrapper';
import SetFinalDate from './SetFinalDate';
import SetInitialDate from './SetInitialDate';

function SetDatetime() {
  return (
    <Wrapper.Default
      flexDirection="column"
      alignItens="start"
      width="32%"
      isActive>
      <span
        style={{ paddingBottom: '5px', fontWeight: 700, lineHeight: '16px' }}>
        Horário entre:
      </span>
      <Wrapper.Default flexDirection="row" isActive style={{ width: '100%' }}>
        <SetInitialDate />
        <span style={{ fontWeight: 700, padding: '0 0.5rem' }}>a</span>
        <SetFinalDate />
      </Wrapper.Default>
    </Wrapper.Default>
  );
}

export default SetDatetime;
